import { render, staticRenderFns } from "./CarrierDownloadLabelButton.vue?vue&type=template&id=588552de&scoped=true&"
import script from "./CarrierDownloadLabelButton.vue?vue&type=script&lang=js&"
export * from "./CarrierDownloadLabelButton.vue?vue&type=script&lang=js&"
import style0 from "./CarrierDownloadLabelButton.vue?vue&type=style&index=0&id=588552de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588552de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588552de')) {
      api.createRecord('588552de', component.options)
    } else {
      api.reload('588552de', component.options)
    }
    module.hot.accept("./CarrierDownloadLabelButton.vue?vue&type=template&id=588552de&scoped=true&", function () {
      api.rerender('588552de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JobOffers/CarrierDownloadLabelButton.vue"
export default component.exports